<template>
  <v-container fluid>
    <!-- 
          <v-toolbar color="transparent" >
   
      <v-toolbar-title >
        Projetos</v-toolbar-title
      >
      <v-spacer></v-spacer>
      <v-btn class="primary" @click="newProject"> +Novo </v-btn>
    </v-toolbar>     -->
    <v-row class="mx-4">
      <div class="text-h3" :class="`blue-grey--text text--darken-2`" color="">
        Projetos
      </div>
      <v-spacer></v-spacer>
      <v-btn class="primary" @click="newProject"> +Novo </v-btn>
    </v-row>

    <v-container style="max-width: 1800px">
      <v-card>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th style="max-width: 50px" class="text-left">Remover</th>
                <th style="max-width: 50px" class="text-left">Código</th>
                <th class="text-left">Data de criação</th>
                <th class="text-left">Cliente</th>
                <th class="text-left">Potência</th>

                <th class="text-left">Abrir</th>
              </tr>
            </thead>
            <tbody>
              <tr
                style="height: 100px"
                v-for="(project, index) in projects"
                :key="index"
              >
                <td style="max-width: 50px">
                  <v-btn
                    class="secondary"
                    style="max-width: 100%"
                    @click="deleteProject(project.id, index)"
                  >
                    <v-icon>mdi-delete</v-icon></v-btn
                  >
                </td>
                <td style="max-width: 50px">{{ project.id }}</td>
                <td style="max-width: 10px">
                  <span v-date-format="project.createdAt"></span>
                </td>

                <td style="max-width: 150px">{{ project.contact.name }}</td>
                <td>
                  <span v-decimal-format="project.solarPlant.dcPower"></span>
                  kWp
                </td>
                <td>
                  <v-btn @click="editProject(project.id)" class="primary">
                    <v-icon>mdi-pencil</v-icon></v-btn
                  >
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
    </v-container>
  </v-container>
</template>

<script>
import Inverter from "@/libraries/classes/devices/Inverter.js";
import Module from "@/libraries/classes/devices/Module.js";
import Service from "@/libraries/classes/devices/Service.js";
import Stringbox from "@/libraries/classes/devices/Stringbox.js";
import Cable from "@/libraries/classes/devices/Cable.js";
import Transformer from "@/libraries/classes/devices/Transformer.js";
import Accessory from "@/libraries/classes/devices/Accessory.js";
import Rail from "@/libraries/classes/devices/Rail.js";
import Structure from "@/libraries/classes/devices/Structure.js";
import Connector from "@/libraries/classes/devices/Connector.js";

//import finance from "./finance.js";
import { Money } from "v-money";
import _ from "lodash";
import hebelApi from "../../../../libraries/hebel/hebelApi";

export default {
  name: "Projects",
  props: [],
  components: {},
  data() {
    return {
      projects: [],
    };
  },
  created() {},
  async mounted() {
    //this.projects = await this.$dao.getProjects(window.eid)
    this.projects = await hebelApi.projects.getAll();
  },
  methods: {
    newProject() {
      this.$session.set("dealId", this.deal.id    );
      this.$router.push("/project");
    },
    deleteProject(projectId, index) {
      //this.$dao.deleteProject(window.eid,projectId )
      hebelApi.projects.delete(projectId);
      this.projects.splice(index, 1);
    },
    editProject(id) {
      this.$router.push("/project/" + id);
    },
  },
};
</script>
<style scoped>
</style>